import axios from "../axios-auth";

export const userService = {
  login,
  getUserList,
  getUsersByShopId,
  saveUser,
  getUserDetail,
  getAllRoles,
  changePasswordById,
  changePassword,
  getAllCaisher,
  getAllSalePerson,
  getSalePersonsByShopId
};

function login(user) {
  return axios.post("/login", user);
}

function getUserList(searchParams, page, size, sortedBy) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }
  let url = "/auth/users?page=" + page + "&size=" + size + "&sort=" + sortedBy;
  if (searchParams.name) {
    url += "&name=" + searchParams.name;
  }
  if (searchParams.status) {
    url += "&status=" + searchParams.status;
  }
  if (searchParams.role) {
    url += "&role=" + searchParams.role;
  }
  return axios.get(url);
}

function saveUser(user) {
  if (user.id) {
    //edit
    return axios.put("/auth/updateuser", user);
  } else {
    // create new
    return axios.post("/auth/user", user);
  }
}

function changePasswordById(user) {
  let obj = {
    id: user.id,
    newPassword: user.password
  };
  return axios.put("/auth/change-password-by-id", obj);
}

function changePassword(user) {
  let obj = {
    oldPassword: user.oldPassword,
    newPassword: user.newPassword
  };
  return axios.put("/auth/change-password-by-current-user", obj);
}

function getUserDetail(id) {
  return axios.get("/auth/user/" + id);
}

function getAllRoles() {
  return axios.get("/auth/roles");
}

function getUsersByShopId(roleName, id) {
  return axios.get("/auth/user-by-shop-id/" + id + "?roleName=" + roleName);
}

function getAllCaisher() {
  return axios.get("/auth/cashiers");
}

function getAllSalePerson() {
  return axios.get("/auth/all-sale-person");
}

function getSalePersonsByShopId(id) {
  return axios.get("/auth/saleperson-by-shop-id/" + id);
}